// @flow
import { mapDataToUI } from "../../dataMappingUIHelpers/uiMapping";
import { cbdAPI } from "../api";
import { download,cbdIdVersion } from "../../utils/downloadLogic";

export type TableState = {
  cbdUIMapping: ?Object,
  isFetchingReferenceData: boolean,
  tableOpen: string,
  data: ?Object
};

type LoadDataAction = {
  type: "LOADDATA",
  payload: ?Object
};

type OpenTableAction = {
  type: "OPENTABLE",
  payload: string
};

type sortByAction = {
  type: "SORTBY",
  payload: string
};

type Action = LoadDataAction | OpenTableAction | sortByAction;

type Dispatch = (action: Action) => any;
type ThunkAction = (dispatch: Dispatch) => any;

const defaultState = {
  isFetchingReferenceData: true,
  data: {},
  cbdUIMapping: {},
  tableOpen: "Material",
  sortBy: "pccSortOrder"
};

export default function reducer(state: TableState = defaultState, action: Action): TableState {
  switch (action.type) {
    case "LOADDATA":
      return {
        ...state,
        data: action.payload,
        cbdUIMapping: action.payload ? mapDataToUI(action.payload) : null,
        isFetchingReferenceData: false
      };
    case "OPENTABLE":
      return {
        ...state,
        tableOpen: action.payload
      };
    case "SORTBY":
      return {
        ...state,
        sortBy: action.payload
      };
    default:
      return state;
  }
}

export function openTable(table: string) {
  return {
    type: "OPENTABLE",
    payload: table
  };
}

export function sortByOrder(sortBy: string) {
  return {
    type: "SORTBY",
    payload: sortBy
  };
}

export function loadedData(data: ?Object) {
  return {
    type: "LOADDATA",
    payload: data
  };
}

export function loadData(accessToken: string): ThunkAction {
  return dispatch => {
    cbdAPI({
      method: "get",
      url: `getCbd?${cbdIdVersion.cbdString}`,
      headers: {
        Authorization: "Bearer " + accessToken
      }
    }).then(
      success => {
        if (success.data.error) {
          console.log(success.data.error);
          dispatch(loadedData(null));
        } else {
          //reintroduce query string into url
          var newurl = `${window.location.protocol}//${window.location.host}${
            window.location.pathname
          }?${cbdIdVersion.cbdString}`;
          window.history.pushState({ path: newurl }, "", newurl);
          //load fetched data into application
          //console.log(success.data);
          dispatch(loadedData(success.data));
        }
      },
      failure => {
        console.log("fail", failure);
        //remove token, as this may be the root of the failure
        //TODO: only remove when it is determined that cause of failure is the validity of the token
        dispatch(loadedData(null));
      }
    );
  };
}

export function downloadExcel(accessToken: string, sortBy): ThunkAction {
  const pccSortOrder = sortBy === "pccSortOrder" ? true : false;
  return dispatch => {
    cbdAPI({
      method: "get",
      responseType: "blob",
      url: `generateCBDExportExcel?${cbdIdVersion.cbdString}&pccSortOrder=${pccSortOrder}`,
      headers: {
        Authorization: "Bearer " + accessToken
      }
    })
      .then(response => {
        const disposition = response.headers["content-disposition"];
        let filename = "";
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }

        download(response.data, filename);
      })
      .catch(error => {
        console.log("Catch error ", error);
      });
  };
}
export function cbdError() {
  return dispatch => {
    //if error just load no data for now. this will show the generic server error message
    dispatch(loadedData(null));
  };
}



// WEBPACK FOOTER //
// ./src/data/modules/ui.js